import { atom, useAtom } from 'jotai';
import { AsignaNotification } from 'types';

const asignaNotificationsAtom = atom<AsignaNotification[]>([]);

export const useAsignaNotifications = () => {
  const [asignaNotifications, setAsignaNotifications] = useAtom(asignaNotificationsAtom);

  return {
    asignaNotifications,
    setAsignaNotifications,
  };
};
